// front-end/src/components/cases-loader/home-cases-loader.js

import { apiGet } from '../../utils/api';
import { config } from '../../config/app-config';
import { loadContentForNewElements } from '../content-editor-src';

async function loadCasesForHome() {
    console.log('[HomeCasesLoader] Starting to load cases for home page...');

    // Проверяем, что мы на главной странице
    if (document.body.getAttribute('data-page') !== 'Home') {
        console.log('[HomeCasesLoader] Not on home page, skipping...');
        return;
    }

    // Находим секцию accordion-cases на главной
    const accordionSection = document.querySelector('#accordion-cases-2[data-section="accordion"]');

    if (!accordionSection) {
        console.log('[HomeCasesLoader] Accordion section not found on home page');
        return;
    }

    // SSR already injected case cards — just wire up accordion behaviour
    if (accordionSection.dataset.ssr === 'true') {
        console.log('[HomeCasesLoader] SSR content detected, initialising accordion only');
        accordionSection.querySelectorAll('.accordion-case-item').forEach(item => {
            setupAccordionFunctionality(item);
        });
        window.addEventListener('resize', handleResize);
        return;
    }

    try {
        // Сначала загружаем все новости с префиксом case-
        const allCasesResponse = await apiGet(`${config.api.paths.news}?limit=100`, { auth: false });

        let allCases = Array.isArray(allCasesResponse) ? allCasesResponse : (allCasesResponse?.items || []);

        // Фильтруем только кейсы (slug начинается с case-) и только опубликованные
        const publishedCases = allCases.filter(item =>
            item.slug && item.slug.startsWith('case-') && item.status === 'published'
        );

        console.log(`[HomeCasesLoader] Found ${publishedCases.length} published cases`);

        if (publishedCases.length === 0) {
            console.log('[HomeCasesLoader] No published cases found');
            accordionSection.innerHTML = '<p style="text-align: center; padding: 20px;">Кейси скоро з\'являться</p>';
            return;
        }
        console.log('Published cases:', publishedCases);

        // Получаем block_data_name из каждого кейса для загрузки блоков
        const caseBlockNames = publishedCases.map(c => c.slug).filter(Boolean);

        console.log('[HomeCasesLoader] Published case block names:', caseBlockNames);

        // Загружаем блоки кейсов
        const casesBlocks = await apiGet(`${config.api.paths.blocksByParent}/cases-section`, { auth: false });

        console.log('[HomeCasesLoader] All case blocks from API:', casesBlocks);

        if (!casesBlocks || casesBlocks.length === 0) {
            console.log('[HomeCasesLoader] No case blocks found');
            return;
        }

        // Фильтруем только те блоки, которые соответствуют опубликованным кейсам
        const publishedCaseBlocks = casesBlocks.filter(block => {
            const isMatch = caseBlockNames.includes(block.data_block_name);
            console.log(`[HomeCasesLoader] Checking block ${block.data_block_name}: ${isMatch ? 'MATCH' : 'NO MATCH'}`);
            return isMatch;
        });

        console.log('[HomeCasesLoader] Filtered published case blocks:', publishedCaseBlocks);

        // Сортируем по order и берем первые 5
        const sortedCases = publishedCaseBlocks
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .slice(0, 5);

        console.log(`[HomeCasesLoader] Loading ${sortedCases.length} cases to home page`);

        // Если не нашли блоки, но есть опубликованные кейсы, используем их напрямую
        if (sortedCases.length === 0 && publishedCases.length > 0) {
            console.log('[HomeCasesLoader] No matching blocks found, using published cases directly');

            // Очищаем существующие блоки в accordion
            accordionSection.innerHTML = '';

            // Создаем accordion элементы напрямую из publishedCases
            publishedCases.slice(0, 5).forEach((caseData, index) => {
                const accordionItem = createAccordionItemFromCaseData(caseData, index);
                accordionSection.appendChild(accordionItem);
            });

            // Загружаем контент для новых элементов
            const contentElements = accordionSection.querySelectorAll('[data-content]');
            if (contentElements.length > 0) {
                loadContentForNewElements(contentElements);
            }

            return;
        }

        // Очищаем существующие блоки в accordion
        accordionSection.innerHTML = '';

        // Создаем accordion элементы для каждого кейса
        sortedCases.forEach((caseBlock, index) => {
            // Находим соответствующие данные из news API
            const caseData = publishedCases.find(c => c.block_data_name === caseBlock.data_block_name);
            const accordionItem = createAccordionItemFromCase(caseBlock, index, caseData);
            accordionSection.appendChild(accordionItem);
        });

        // Загружаем контент для новых элементов
        const contentElements = accordionSection.querySelectorAll('[data-content]');
        if (contentElements.length > 0) {
            loadContentForNewElements(contentElements);
        }

        console.log('[HomeCasesLoader] Cases loaded successfully');

    } catch (error) {
        console.error('[HomeCasesLoader] Error loading cases:', error);
    }
}

function createAccordionItemFromCase(caseBlock, index, caseData) {
    const displayNumber = index + 1;
    const blockName = caseBlock.data_block_name;
    const caseSlug = caseData?.slug || `${blockName}`;

    // Создаем accordion item на основе данных кейса
    const accordionItem = document.createElement('div');
    accordionItem.className = 'accordion-case-item';
    accordionItem.setAttribute('data-block-name', `home-case-${displayNumber}`);
    accordionItem.setAttribute('data-order', String(index));
    accordionItem.style.position = 'relative';

    // language=HTML
    const accordionHTML = `
        <div class="accordion-header container-fluid">
            <div class="row align-items-center">
                <div class="col-md-6 d-none d-md-block">
                    <div class="case-number-header"><span>${displayNumber}</span></div>
                </div>

                <div class="col-12 col-md-6 d-flex align-items-center justify-content-between">
                    <div class="case-number-header d-md-none"><span>${displayNumber}</span></div>

                    <h4 class="header-text-accordion" data-content="${blockName}-title" data-global="true"></h4>
                    <div class="accordion-toggle" aria-label="Розгорнути">
                        <img src="/images/accordion-closed.svg" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="accordion-content collapsed">
            <div class="accordion-content-inner row">
                <div class="col-lg-6 image-half">
                    <div class="d-flex d-md-none">
                        <div class="case-number-header"><span>${displayNumber}</span></div>
                        <h4 class="mobile-header" data-content="${blockName}-title" data-global="true"></h4>
                        <div class="close-accordion" aria-label="Згорнути" type="button">
                            <img src="/images/opened-accordion.svg" alt="">
                        </div>
                    </div>
                    <div class="case-number-header d-none d-md-block"><span>${displayNumber}</span></div>

                    <div class="image-container">
                        <img class="case-image" src="" alt="" data-content="${blockName}-image" data-type="image"
                             data-global="true">
                    </div>
                </div>

                <div class="col-lg-6 description-half d-md-flex justify-content-between">
                    <div>
                        <h4 data-content="${blockName}-title" data-global="true"></h4>
                        <div class="case-problem-solution">
                            <p data-content="${blockName}-problem" data-type="textarea" data-global="true"></p>
                        </div>
                        <a class="case-link" href="/case/${caseSlug}">
                            Читати повний кейс
                        </a>
                    </div>
                    <div class="close-accordion d-none d-md-block" aria-label="Згорнути" type="button">
                        <img src="/images/opened-accordion.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
    `;

    accordionItem.innerHTML = accordionHTML;

    // Дебаг для проверки span'ов
    console.log('Accordion item HTML:', accordionItem.innerHTML);
    const spans = accordionItem.querySelectorAll('.case-number span, .case-number-header span');
    console.log('Found spans:', spans.length, spans);

    // Добавляем функциональность accordion
    setupAccordionFunctionality(accordionItem);

    return accordionItem;
}

function createAccordionItemFromCaseData(caseData, index) {
    const displayNumber = index + 1;
    const blockName = caseData.block_data_name || caseData.slug.replace('case-', '');
    const caseSlug = caseData.slug;

    // Создаем accordion item на основе данных кейса
    const accordionItem = document.createElement('div');
    accordionItem.className = 'accordion-case-item';
    accordionItem.setAttribute('data-block-name', `home-case-${displayNumber}`);
    accordionItem.setAttribute('data-order', String(index));
    accordionItem.style.position = 'relative';

    // language=HTML
    const accordionHTML = `
        <div class="accordion-header container-fluid">
            <div class="row align-items-center">
                <div class="col-md-6 d-none d-md-block">
                    <div class="case-number-header"><span>${displayNumber}</span></div>
                </div>

                <div class="col-12 col-md-6 d-flex align-items-center justify-content-between">
                    <div class="case-number-header d-md-none"><span>${displayNumber}</span></div>

                    <h4 class="header-text-accordion">${caseData.title ? caseData.title.replace('Case: ', '') : 'Кейс'}</h4>
                    <div class="accordion-toggle" aria-label="Розгорнути">
                        <img src="/images/accordion-closed.svg" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="accordion-content collapsed">
            <div class="accordion-content-inner row">
                <div class="col-lg-6 image-half">
                    <div class="d-flex d-md-none">
                        <div class="case-number-header"><span>${displayNumber}</span></div>
                        <h4 class="mobile-header">${caseData.title ? caseData.title.replace('Case: ', '') : 'Кейс'}</h4>
                        <div class="close-accordion" aria-label="Згорнути" type="button">
                            <img src="/images/opened-accordion.svg" alt="">
                        </div>
                    </div>
                    <div class="case-number-header d-none d-md-block"><span>${displayNumber}</span></div>

                    <div class="image-container">
                        <img class="case-image" src="" alt="" data-content="${blockName}-image" data-type="image"
                             data-global="true">
                    </div>
                </div>

                <div class="col-lg-6 description-half d-md-flex justify-content-between">
                    <div>
                        <h4>${caseData.title ? caseData.title.replace('Case: ', '') : 'Кейс'}</h4>
                        <div class="case-problem-solution">
                            <p>${caseData.preview_text || 'Опис кейсу'}</p>
                        </div>
                        <a class="case-link" href="/case/${caseSlug}">
                            Читати повний кейс
                        </a>
                    </div>
                    <div class="close-accordion d-none d-md-block" aria-label="Згорнути" type="button">
                        <img src="/images/opened-accordion.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
    `;

    accordionItem.innerHTML = accordionHTML;

    // Дебаг для проверки span'ов
    console.log('Accordion item HTML (CaseData):', accordionItem.innerHTML);
    const spans = accordionItem.querySelectorAll('.case-number span, .case-number-header span');
    console.log('Found spans (CaseData):', spans.length, spans);

    // Добавляем функциональность accordion
    setupAccordionFunctionality(accordionItem);

    return accordionItem;
}

function setupAccordionFunctionality(accordionItem) {
    const toggleButton = accordionItem.querySelector('.accordion-toggle');
    const header = accordionItem.querySelector('.accordion-header');
    const content = accordionItem.querySelector('.accordion-content');
    const closeButtons = accordionItem.querySelectorAll('.close-accordion');

    const toggleAccordion = (e) => {
        e.stopPropagation();

        const isCollapsed = content.classList.contains('collapsed');

        // Если раскрываем текущий элемент, закрываем все остальные
        if (isCollapsed) {
            const sectionElement = accordionItem.parentElement;
            if (sectionElement) {
                const expandedItems = sectionElement.querySelectorAll('.accordion-case-expanded');
                expandedItems.forEach(item => {
                    if (item !== accordionItem) {
                        collapseAccordionItem(item);
                    }
                });
            }
        }

        // Переключаем классы для текущего элемента
        content.classList.toggle('collapsed', !isCollapsed);
        content.classList.toggle('expanded', isCollapsed);
        accordionItem.classList.toggle('accordion-case-expanded', isCollapsed);

        // Обновляем доступность
        toggleButton.setAttribute('aria-label', isCollapsed ? 'Свернуть' : 'Развернуть');

        // Анимируем высоту
        if (isCollapsed) {
            content.style.display = 'block';
            const scrollHeight = content.scrollHeight;
            content.style.maxHeight = `${scrollHeight}px`;
            header.style.display = 'none';
        } else {
            content.style.maxHeight = '0';
            header.style.display = 'block';

            setTimeout(() => {
                if (content.classList.contains('collapsed')) {
                    content.style.display = 'none';
                }
            }, 500);
        }
    };

    // Обработчики событий
    toggleButton.addEventListener('click', toggleAccordion);
    header.addEventListener('click', function(e) {
        if (e.target !== toggleButton && !toggleButton.contains(e.target)) {
            toggleAccordion(e);
        }
    });

    // Добавляем обработчик для всех кнопок закрытия
    closeButtons.forEach(closeButton => {
        closeButton.addEventListener('click', toggleAccordion);
    });

    // По умолчанию контент скрыт
    content.style.maxHeight = '0';
    content.style.display = 'none';
}

function collapseAccordionItem(accordionItem) {
    const itemHeader = accordionItem.querySelector('.accordion-header');
    const itemContent = accordionItem.querySelector('.accordion-content');
    const itemToggleButton = accordionItem.querySelector('.accordion-toggle');

    itemContent.classList.remove('expanded');
    itemContent.classList.add('collapsed');
    accordionItem.classList.remove('accordion-case-expanded');

    if (itemToggleButton) {
        itemToggleButton.setAttribute('aria-label', 'Развернуть');
    }

    itemContent.style.maxHeight = '0';

    if (itemHeader) {
        itemHeader.style.display = 'flex';
    }

    setTimeout(() => {
        if (itemContent.classList.contains('collapsed')) {
            itemContent.style.display = 'none';
        }
    }, 500);
}

// Пересчет высоты при изменении размера экрана
function recalculateExpandedAccordions() {
    const expandedItems = document.querySelectorAll('.accordion-case-expanded .accordion-content.expanded');
    expandedItems.forEach(content => {
        // Временно убираем maxHeight чтобы получить реальную высоту
        const currentMaxHeight = content.style.maxHeight;
        content.style.maxHeight = 'none';
        const newScrollHeight = content.scrollHeight;
        content.style.maxHeight = `${newScrollHeight}px`;

        console.log('[HomeCasesLoader] Recalculated height from', currentMaxHeight, 'to', `${newScrollHeight}px`);
    });
}

// Добавляем debounced resize listener
let resizeTimeout;
function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        recalculateExpandedAccordions();
    }, 150); // Ждем 150ms после окончания resize
}

// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', () => {
    // Ждем немного, чтобы убедиться что block system загрузился
    setTimeout(() => {
        loadCasesForHome();
    }, 1000);

    // Добавляем listener для resize
    window.addEventListener('resize', handleResize);
});

// Экспорт функций для использования в других модулях
export { loadCasesForHome, recalculateExpandedAccordions };